import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import WebHeader from "./WebHeader";
import WebFooter from "./WebFooter";
import axios from "axios";

const JobList = () => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadJobs(); }, []);

  const loadJobs = async () => {
    try {
      const res = await axios.get("http://144.24.143.236:5000/api/jobs");
      if (res.data.status) setJobs(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filtered = jobs.filter(j =>
    `${j.title} ${j.company} ${j.location}`.toLowerCase().includes(search.toLowerCase())
  );

  const premiumJobs = [
    { id: 1, title: "Senior React Developer", company: "TechCorp India", location: "Bangalore", salary: "₹18–25 LPA", tag: "Hot" },
    { id: 2, title: "Product Manager", company: "FinEdge Solutions", location: "Mumbai", salary: "₹20–30 LPA", tag: "New" },
    { id: 3, title: "Data Scientist", company: "Analytics Hub", location: "Hyderabad", salary: "₹15–22 LPA", tag: "Urgent" },
  ];

  const tagColor = { Hot: "#ef4444", New: "#16a34a", Urgent: "#f59e0b" };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');

        .jl-root { font-family: 'DM Sans', sans-serif; background: #f5f6fa; min-height: 100vh; }

        .jl-hero {
          background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #1d4ed8 100%);
          padding: 48px 0 56px;
          position: relative; overflow: hidden;
        }
        .jl-hero::before {
          content: ''; position: absolute; inset: 0;
          background: radial-gradient(ellipse at 80% 50%, rgba(99,102,241,.25) 0%, transparent 60%);
        }
        .jl-hero-title {
          font-family: 'Syne', sans-serif; font-weight: 800;
          font-size: clamp(26px, 4vw, 38px); color: #fff; margin-bottom: 6px;
        }
        .jl-hero-sub { color: #94a3b8; font-size: 15px; margin-bottom: 28px; }

        .jl-search-wrap {
          display: flex; background: #fff; border-radius: 12px;
          overflow: hidden; box-shadow: 0 8px 32px rgba(0,0,0,.18);
          max-width: 580px;
        }
        .jl-search-input {
          flex: 1; border: none; outline: none; padding: 14px 18px;
          font-size: 15px; font-family: 'DM Sans', sans-serif; color: #1e293b;
        }
        .jl-search-btn {
          background: #2563eb; color: #fff; border: none;
          padding: 0 24px; font-weight: 700; font-size: 14px;
          cursor: pointer; transition: background .2s; white-space: nowrap;
        }
        .jl-search-btn:hover { background: #1d4ed8; }

        .jl-badge {
          display: inline-block; padding: 2px 10px; border-radius: 20px;
          font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px;
        }

        .jl-card {
          background: #fff; border-radius: 14px; padding: 22px 24px;
          border: 1.5px solid #e8eaf0; cursor: pointer;
          transition: box-shadow .22s, border-color .22s, transform .18s;
          position: relative; overflow: hidden;
        }
        .jl-card:hover {
          box-shadow: 0 8px 32px rgba(37,99,235,.13);
          border-color: #2563eb; transform: translateY(-2px);
        }
        .jl-card::before {
          content: ''; position: absolute; left: 0; top: 0; bottom: 0;
          width: 4px; background: #2563eb; opacity: 0; transition: opacity .2s;
          border-radius: 14px 0 0 14px;
        }
        .jl-card:hover::before { opacity: 1; }

        .jl-card-title {
          font-family: 'Syne', sans-serif; font-weight: 700;
          font-size: 17px; color: #0f172a; margin-bottom: 4px;
        }
        .jl-card-company { font-size: 13px; color: #2563eb; font-weight: 600; margin-bottom: 10px; }
        .jl-card-meta { display: flex; gap: 16px; flex-wrap: wrap; }
        .jl-card-meta span {
          font-size: 13px; color: #64748b; display: flex; align-items: center; gap: 4px;
        }
        .jl-card-footer {
          display: flex; justify-content: space-between; align-items: center;
          margin-top: 14px; padding-top: 14px; border-top: 1px solid #f1f5f9;
        }
        .jl-apply-btn {
          background: #eff6ff; color: #2563eb; border: none;
          border-radius: 8px; padding: "6px 16px"; font-weight: 700;
          font-size: 13px; cursor: pointer; transition: background .2s;
          padding: 6px 16px;
        }
        .jl-apply-btn:hover { background: #2563eb; color: #fff; }

        .jl-section-title {
          font-family: 'Syne', sans-serif; font-weight: 700;
          font-size: 16px; color: #0f172a; margin-bottom: 16px;
          display: flex; align-items: center; gap: 8px;
        }

        .jl-premium-card {
          background: #fff; border-radius: 12px; padding: 14px 16px;
          border: 1.5px solid #e8eaf0; margin-bottom: 12px; cursor: pointer;
          transition: box-shadow .2s, border-color .2s;
          display: flex; gap: 12px; align-items: flex-start;
        }
        .jl-premium-card:hover { box-shadow: 0 4px 16px rgba(37,99,235,.1); border-color: #93c5fd; }
        .jl-premium-logo {
          width: 42px; height: 42px; border-radius: 10px;
          background: linear-gradient(135deg, #dbeafe, #eff6ff);
          display: flex; align-items: center; justify-content: center;
          font-size: 20px; flex-shrink: 0;
        }

        .jl-stats {
          display: flex; gap: 20px; margin-bottom: 20px; flex-wrap: wrap;
        }
        .jl-stat {
          background: #fff; border-radius: 10px; padding: 12px 18px;
          border: 1px solid #e8eaf0; flex: 1; min-width: 100px; text-align: center;
        }
        .jl-stat-num { font-family: 'Syne', sans-serif; font-size: 22px; font-weight: 800; color: #2563eb; }
        .jl-stat-label { font-size: 11px; color: #94a3b8; font-weight: 500; margin-top: 2px; }

        .jl-empty { text-align: center; padding: 60px 20px; color: #94a3b8; }
        .jl-empty-icon { font-size: 48px; margin-bottom: 12px; }

        .jl-skeleton {
          background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
          background-size: 200% 100%; animation: shimmer 1.4s infinite;
          border-radius: 8px;
        }
        @keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }

        .jl-count-pill {
          background: #2563eb; color: #fff; border-radius: 20px;
          padding: 2px 10px; font-size: 12px; font-weight: 700;
        }
      `}</style>

      <div className="jl-root">
        <WebHeader />

        {/* Hero / Search */}
        <div className="jl-hero">
          <div className="container" style={{ position: "relative", zIndex: 1 }}>
            <div className="jl-hero-title">Find Your Next Opportunity</div>
            <div className="jl-hero-sub">{jobs.length} open positions across India</div>
            <div className="jl-search-wrap">
              <span style={{ padding: "14px 0 14px 16px", fontSize: 18 }}>🔍</span>
              <input
                className="jl-search-input"
                placeholder="Search by title, company, location..."
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
              <button className="jl-search-btn">Search</button>
            </div>
          </div>
        </div>

        <main style={{ padding: "32px 0 60px" }}>
          <div className="container">
            <div className="row g-4">

              {/* ── Left: Job Cards ── */}
              <div className="col-lg-8">

                {/* Stats row */}
                <div className="jl-stats">
                  {[
                    ["💼", jobs.length, "Total Jobs"],
                    ["🏢", [...new Set(jobs.map(j => j.company))].length, "Companies"],
                    ["📍", [...new Set(jobs.map(j => j.location))].length, "Locations"],
                  ].map(([icon, num, label]) => (
                    <div key={label} className="jl-stat">
                      <div style={{ fontSize: 20 }}>{icon}</div>
                      <div className="jl-stat-num">{num}</div>
                      <div className="jl-stat-label">{label}</div>
                    </div>
                  ))}
                </div>

                {/* Heading */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
                  <div className="jl-section-title" style={{ marginBottom: 0 }}>
                    Latest Jobs
                    <span className="jl-count-pill">{filtered.length}</span>
                  </div>
                  {search && (
                    <button onClick={() => setSearch("")} style={{
                      background: "none", border: "1px solid #e2e8f0", borderRadius: 6,
                      padding: "4px 12px", fontSize: 12, cursor: "pointer", color: "#64748b"
                    }}>Clear ✕</button>
                  )}
                </div>

                {/* Loading skeletons */}
                {loading && [1, 2, 3].map(i => (
                  <div key={i} style={{ background: "#fff", borderRadius: 14, padding: 24, marginBottom: 14, border: "1.5px solid #e8eaf0" }}>
                    <div className="jl-skeleton" style={{ height: 20, width: "60%", marginBottom: 10 }} />
                    <div className="jl-skeleton" style={{ height: 14, width: "35%", marginBottom: 16 }} />
                    <div style={{ display: "flex", gap: 12 }}>
                      <div className="jl-skeleton" style={{ height: 12, width: 80 }} />
                      <div className="jl-skeleton" style={{ height: 12, width: 80 }} />
                    </div>
                  </div>
                ))}

                {/* Empty state */}
                {!loading && filtered.length === 0 && (
                  <div className="jl-empty">
                    <div className="jl-empty-icon">🔎</div>
                    <div style={{ fontWeight: 600, fontSize: 16, color: "#475569" }}>No jobs found</div>
                    <div style={{ fontSize: 13, marginTop: 4 }}>Try a different search term</div>
                  </div>
                )}

                {/* Job cards */}
                {!loading && filtered.map((job, idx) => (
                  <div
                    key={job.id}
                    className="jl-card"
                    style={{ marginBottom: 14, animationDelay: `${idx * 0.05}s` }}
                    onClick={() => navigate(`/job/${job.id}`)}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 8 }}>
                      <div style={{ flex: 1 }}>
                        <div className="jl-card-title">{job.title}</div>
                        <div className="jl-card-company">🏢 {job.company}</div>
                        <div className="jl-card-meta">
                          {job.location && <span>📍 {job.location}</span>}
                          {job.salary && <span>💰 {job.salary}</span>}
                          {job.job_type && <span>⏱ {job.job_type}</span>}
                        </div>
                      </div>
                      <span className="jl-badge" style={{ background: "#eff6ff", color: "#2563eb" }}>
                        {job.job_type || "Full Time"}
                      </span>
                    </div>

                    {job.description && (
                      <p style={{
                        fontSize: 13, color: "#64748b", marginTop: 10, marginBottom: 0,
                        lineHeight: 1.6,
                        display: "-webkit-box", WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical", overflow: "hidden"
                      }}>
                        {job.description}
                      </p>
                    )}

                    <div className="jl-card-footer">
                      <span style={{ fontSize: 12, color: "#94a3b8" }}>
                        🕐 Posted recently
                      </span>
                      <button className="jl-apply-btn">View & Apply →</button>
                    </div>
                  </div>
                ))}
              </div>

              {/* ── Right: Premium Jobs ── */}
              <div className="col-lg-4">
                <div style={{ position: "sticky", top: 20 }}>

                  {/* Premium Jobs */}
                  <div style={{ background: "#fff", borderRadius: 14, padding: 20, border: "1.5px solid #e8eaf0", marginBottom: 16 }}>
                    <div className="jl-section-title">
                      ⭐ Premium Jobs
                    </div>
                    {premiumJobs.map(pj => (
                      <div key={pj.id} className="jl-premium-card">
                        <div className="jl-premium-logo">🏢</div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                            <div style={{ fontWeight: 700, fontSize: 14, color: "#0f172a", marginBottom: 2 }}>{pj.title}</div>
                            <span className="jl-badge" style={{ background: tagColor[pj.tag] + "1a", color: tagColor[pj.tag], flexShrink: 0, marginLeft: 6 }}>
                              {pj.tag}
                            </span>
                          </div>
                          <div style={{ fontSize: 12, color: "#2563eb", fontWeight: 600 }}>{pj.company}</div>
                          <div style={{ fontSize: 12, color: "#64748b", marginTop: 4 }}>
                            📍 {pj.location} &nbsp;·&nbsp; 💰 {pj.salary}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* CTA Banner */}
                  <div style={{
                    background: "linear-gradient(135deg, #1e3a5f, #2563eb)",
                    borderRadius: 14, padding: "20px", color: "#fff", textAlign: "center"
                  }}>
                    <div style={{ fontSize: 28, marginBottom: 8 }}>🚀</div>
                    <div style={{ fontFamily: "'Syne', sans-serif", fontWeight: 700, fontSize: 16, marginBottom: 6 }}>
                      Post a Job
                    </div>
                    <div style={{ fontSize: 13, color: "#93c5fd", marginBottom: 14 }}>
                      Reach thousands of qualified candidates today
                    </div>
                    <button style={{
                      background: "#fff", color: "#2563eb", border: "none",
                      borderRadius: 8, padding: "8px 20px", fontWeight: 700,
                      fontSize: 13, cursor: "pointer", width: "100%"
                    }}>
                      Get Started →
                    </button>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </main>

        <WebFooter />
      </div>
    </>
  );
};

export default JobList;
